﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VaultControllerStatusEnum = void 0;
var VaultControllerStatusEnum;
(function (VaultControllerStatusEnum) {
    //0 - Created 1 - Splitting 2 - Swapping 3 - WaitICR 
    VaultControllerStatusEnum[VaultControllerStatusEnum["Created"] = 0] = "Created";
    VaultControllerStatusEnum[VaultControllerStatusEnum["Splitting"] = 1] = "Splitting";
    VaultControllerStatusEnum[VaultControllerStatusEnum["Swapping"] = 2] = "Swapping";
    VaultControllerStatusEnum[VaultControllerStatusEnum["WaitTargetICR"] = 3] = "WaitTargetICR";
    VaultControllerStatusEnum[VaultControllerStatusEnum["VaultClosed"] = 4] = "VaultClosed";
})(VaultControllerStatusEnum = exports.VaultControllerStatusEnum || (exports.VaultControllerStatusEnum = {}));
//# sourceMappingURL=VaultControllerStatusEnum.js.map